module.exports = __webpack_public_path__ + "static/media/cory.ad5393f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/About/cory.jpg
// module id = 633
// module chunks = 0